import { makeAutoObservable } from 'mobx'
import { keepAlive } from '@methods/keepAlive'
import { RootStore } from './Root.store'

import { KEEP_SESSION_ALIVE_INTERVAL_MS } from '@constants/session'

export class TrackingStore {
  private rootStore: RootStore
  private visibilityHandler?: () => void
  shouldKeepAlive: boolean = true
  keepSessionAliveInterval: ReturnType<typeof setInterval> | undefined = undefined

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, { visibilityHandler: false } as any)
    this.rootStore = rootStore
  }

  setShouldKeepAlive(payload: boolean): void {
    this.shouldKeepAlive = payload
  }

  async keepSessionAlive() {
    if (this.shouldKeepAlive) {
      keepAlive()
    }
  }

  initKeepSessionAliveInterval() {
    this.shouldKeepAlive = true

    if (!this.keepSessionAliveInterval) {
      this.keepSessionAliveInterval = setInterval(
        () => void this.keepSessionAlive(),
        KEEP_SESSION_ALIVE_INTERVAL_MS
      )

      const handler = () => {
        if (document.visibilityState === 'visible' && this.keepSessionAliveInterval) {
          void this.keepSessionAlive()
        }
      }
      this.visibilityHandler = handler
      document.addEventListener('visibilitychange', handler)
    }
  }

  disposeKeepSessionAliveInterval() {
    this.shouldKeepAlive = false

    if (this.keepSessionAliveInterval) {
      clearInterval(this.keepSessionAliveInterval)
      this.keepSessionAliveInterval = undefined
    }

    if (this.visibilityHandler) {
      document.removeEventListener('visibilitychange', this.visibilityHandler)
      this.visibilityHandler = undefined
    }
  }
}
